// V1 default action taxonomy for bond delegations.
//
// The Seitiate engine schemas (~/Dev/seitiate/app/schemas/agent_governance.py)
// accept allowed_actions / gated_actions as free-form string lists; there is
// no centralized constant. The design contract
// (~/Dev/context-engine-studio/docs/design/BOARD-BOND-DELEGATED-AGENTS-CONTRACT-V1.md
// lines 238–268) defines behavior classes ("claim an unassigned task",
// "merge a PR") rather than formal action enum names.
//
// This file is the UI's interim source of truth. A follow-up dispatch is
// filed to centralize this taxonomy in the engine — when that lands, this
// file should re-export from a shared contract package.

export const V1_DEFAULT_ALLOWED_ACTIONS: readonly string[] = [
  'task.claim',
  'task.comment',
  'task.complete',
];

export const V1_DEFAULT_GATED_ACTIONS: readonly string[] = ['task.dispatch'];
